import { render } from "./SimpleLayout.vue?vue&type=template&id=dd7e1790"
import script from "./SimpleLayout.vue?vue&type=script&lang=ts"
export * from "./SimpleLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script